// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"f9262bc6","168":"4c890252","303":"6dca2a06","702":"b83d9778","914":"402f5bc6"}[chunkId] + ".chunk.js";
};